import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { User } from '../../../models/user.model';
import { ShowPerformance } from '../../../models/showperformance.model';
import { UserRole } from '../enums/user-roles.enum';

@Component({
    selector: 'app-crew-select-dropdown',
    templateUrl: './crew-select-dropdown.component.html',
    styleUrls: ['./crew-select-dropdown.component.scss'],
    standalone: false
})
export class CrewSelectDropdownComponent implements OnChanges {

    @Input() public users: User[];
    @Input() public performance: ShowPerformance | null = null;
    @Input() public role: UserRole | null = null;

    @Input() selectedUserId: number;
    @Output() selectedUserIdChange = new EventEmitter<number>();

    protected filteredUsers: User[];

    selectUser($event: any): void {
        this.selectedUserId = $event.target.value;
        this.selectedUserIdChange.emit(this.selectedUserId);
    }

    ngOnChanges() {
        this.filterUsers();
    }

    private filterUsers(): void {

        if (!this.performance) {
            this.filteredUsers = this.users;
            return;
        }

        let selectedUserForProvidedRole: User | null;
        if (this.role) {
            switch (this.role) {
                case UserRole.Stagemanager: {
                    selectedUserForProvidedRole = this.performance.scheduledStagemanager;
                    break;
                }
                case UserRole.Showcaller: {
                    selectedUserForProvidedRole = this.performance.scheduledShowcaller;
                    break;
                }
                case UserRole.FloorTechnician: {
                    selectedUserForProvidedRole = this.performance.scheduledFloortechnician;
                    break;
                }
                case UserRole.Troubleshooter: {
                    selectedUserForProvidedRole = this.performance.scheduledTroubleshooter;
                    break;
                }
                case UserRole.Toneelmeester: {
                    selectedUserForProvidedRole = this.performance.scheduledToneelmeester;
                    break;
                }
                default: {
                    selectedUserForProvidedRole = null;
                    break;
                }
            }
        }

        const alreadyScheduledUsers = this.users.filter(user => {
            if (
                user.id === this.performance.scheduledStagemanager?.id                || user.id === this.performance.scheduledShowcaller?.id                || user.id === this.performance.scheduledFloortechnician?.id                || user.id === this.performance.scheduledTroubleshooter?.id                || user.id === this.performance.scheduledToneelmeester?.id) {
                return user;
            }
        });

        // TODO: Enable this if you figured out how to update the performance
        if (false) {
            this.filteredUsers = this.users.filter(user => !alreadyScheduledUsers.includes(user));
            if (selectedUserForProvidedRole) {
                this.filteredUsers.push(selectedUserForProvidedRole);
                this.filteredUsers.sort((a, b) => (a.firstName > b.firstName ? 1 : -1));
            }
        } else {
            this.filteredUsers = [...this.users].sort((a, b) =>
                (a.firstName ?? '').localeCompare(b.firstName ?? '')
            );
        }

    }
}
